import { DateTimeFormat } from "@advapacs/common";
import { SettingGeneralAction } from "./slices";
import axios from "axios";
import { AppThunk } from "../../../../config/store";
import { getUser } from "../../../../pages/login/ducks/operations";

export const updateDateTimeFormat =
  (payload: DateTimeFormat): AppThunk =>
  async (dispatch) => {
    try {
      const composedUrl = "/settings/datetime/format";
      dispatch(SettingGeneralAction.updateDateTimeFormatStart());
      await axios.put(composedUrl, payload);
      dispatch(SettingGeneralAction.updatedDateTimeFormatSuccess());
      dispatch(getUser());
    } catch (err) {
      dispatch(
        SettingGeneralAction.updateDateTimeFormatFailed(err?.response?.data)
      );
    }
  };
